import LocalStorageService from '../../LocalStorage/LocalStorage.service';
import Dates from '../../../utils/dates';

class CommunicationService {
  static #checkExpirationDateConfig(expire) {
    return (expire && Dates.get(expire, 'DD-MM-yyyy').compareIsAfter(new Date())) || !expire;
  }

  static #checkInitialDateConfig(initDate) {
    return (initDate && Dates.get(initDate, 'DD-MM-yyyy').compareIsBefore(new Date())) || !initDate;
  }

  static #showByDateLastResponse(variable, eachDays = 30) {
    const dateLastResponse = LocalStorageService.get(variable);
    return (
      (dateLastResponse &&
        Dates.getWithAddDays(eachDays, dateLastResponse).compareIsBefore(new Date())) ||
      !dateLastResponse
    );
  }

  static checkTypeDate(variable, initDate, expireDate, eachDays) {
    return (
      CommunicationService.showByDate(initDate, expireDate) &&
      CommunicationService.#showByDateLastResponse(variable, eachDays)
    );
  }

  static saveVariable(variable, value) {
    LocalStorageService.set(variable, value);
  }

  static checkPathnameConfig(currentPath, paths) {
    const validation = paths?.some((path) => {
      if (path === '/') {
        return path === currentPath;
      }

      return currentPath.includes(path);
    });

    return validation || !paths;
  }

  static showByDate(initDate, expireDate) {
    return (
      CommunicationService.#checkInitialDateConfig(initDate) &&
      CommunicationService.#checkExpirationDateConfig(expireDate)
    );
  }

  static checkCircleConfig(acceptCircle, isCircle) {
    return (!acceptCircle && typeof isCircle !== 'undefined' && !isCircle) || acceptCircle;
  }

  static checkTypeBoolean(variable, expire) {
    return (
      !LocalStorageService.get(variable) && CommunicationService.#checkExpirationDateConfig(expire)
    );
  }
}

export default CommunicationService;
